import { Box, Button, CircularProgress, Typography } from "@mui/material";
import Searchbar from "@/components/searchBox/searchBox";
import React, { useState } from "react";
import PresetFileCard from "./PresetFileCard";
import { MuiButtonStyle } from "src/theme/buttonStyle";
import {
  reset,
  endFolderProjectCreate,
  startFolderProjectCreate,
  updateShowDialog,
  updateProjectCreate,
  setLinkedAccountStep,
  setUploadedSuccesfully,
  setGoogleDriveStep,
  setSelectedGDCustomPreset,
  updateStatus,
  updateFolderProgress,
} from "src/redux/reducers/file-upload.reducer";
import { dispatch, useSelector } from "src/redux/store";
import useAuth from "src/hooks/useAuth";
import { createGoogleDriveJob, sendGoogleDriveInstruction, createProject } from "src/services/file-upload";
import useToast from "src/hooks/useToast";
import SvgIconStyle from "src/components/SvgIconStyle";
import useComponentVisible from "src/hooks/useComponentVisible";
import { STEPS, UPLOAD_STATUS, ERROR_MESSAGES, } from "src/utils/constant";
import AddInstruction from "./googleDriveUtils/AddInstruction";
import { saveShopifyAccountBulkUpload } from "src/services/job-order";
import { completeStrapiData } from "src/strapiData";
import { removeUnReadNotification } from "src/redux/reducers/notification.reducer";
import { get, values } from "lodash";
import { getUploadProgress } from "src/utils/helpers";
import { useEffect } from "react";


//--------------------------------------------
const infoStyle={
  px:'24px',
  height:'52px',
  display:'flex',
  justifyContent:'space-between',
  alignItems:'center',
  borderBottom:'1px solid #EEEEEE'
}

//--------------------------------------------
const SelectPresetAndConfirm = ({showFileUploadSuccess, setSuccessText}) => {
  const { user } = useAuth();
  const Toast = useToast();
  const {
    step,
    name,
    files,
    folders,
    fileUploadId,
    linkedAccountType,
    selectedLinkedAccountProjectList,
    selectedMarketPlaceId,
    googleDriveCustomPreset,
    selectedGDCustomPreset,
    googleDriveUserLink,
    userGDFileImageLength,
    userGoogleDriveFilesName,
    googleDriveInstruction
  } = useSelector((state) => state.fileUpload);
  const [searchResult, setSearchResult] = useState(
    googleDriveCustomPreset || []
  );
  const [isLoading, setIsLoading] = useState(false);
  const [showInstruction, setShowInstruction] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [totalCredit, setTotalCredit] = useState(0);
  const [totalImages, setTotalImages] = useState(0);
  const {entireStrapiData} = useSelector((state)=> state.strapi);
  const CreateProjectData = entireStrapiData?.CreateProjectWebApp?.CreateProjectWebApp;
  const defaultStrapiData = completeStrapiData?.CreateProjectWebApp?.CreateProjectWebApp;
  const { ref, isComponentVisible, setIsComponentVisible } =
    useComponentVisible(false);

  const onSearchHandler = (value) => {
    if (value) {
      setIsComponentVisible(true);
      const searchPreset = googleDriveCustomPreset?.filter((obj) =>
        obj?.name.toUpperCase().includes(value.toUpperCase())
      );
      setSearchResult(searchPreset);
    } else {
      setIsComponentVisible(false);
      setSearchResult(googleDriveCustomPreset);
    }
  };

  const onSelectHandler = (selected) => {
    const alreadyExist = selectedGDCustomPreset?._id === selected?._id;
    if (alreadyExist) {
      dispatch(setSelectedGDCustomPreset({}));
      setTotalCredit(0);
    } else {
      setErrorMessage(false);
      dispatch(setSelectedGDCustomPreset(selected));
    }
  };
  
  const creditCalculateHandler = () =>{
    if(!selectedGDCustomPreset){
      setTotalCredit(0);
      return;
    }
    if(step === STEPS?.FILE_UPLOAD){
      if(selectedGDCustomPreset?.cost){
      setTotalCredit(Object.values(files)?.length * selectedGDCustomPreset?.cost);
      }
      setTotalImages(Object.values(files)?.length);
    }else if(step === STEPS?.FOLDER_UPLOAD){
      let totalImage = 0;
      values(folders).forEach((folder)=>{
        if(folder?.files.length)
        totalImage += folder?.files.length
      })
      if(selectedGDCustomPreset?.cost){
      setTotalCredit(totalImage * selectedGDCustomPreset?.cost);
      };
      setTotalImages(totalImage);
    }else if(step === STEPS?.GOOGLE_DRIVE){
      if(selectedGDCustomPreset?.cost){
      setTotalCredit(userGDFileImageLength * selectedGDCustomPreset?.cost);
      }
      setTotalImages(userGDFileImageLength);
    }
  };

  const fileUploadConfirmHandler = async() => {
    if (!name?.trim()) {
      Toast.error(`${CreateProjectData?.PleaseEnterProjName || defaultStrapiData?.PleaseEnterProjName}`);
      return;
    }
    try {
      setIsLoading(true);
      const payload = {
        imageURLs: Object.values(files).map(
          (file) => file?.imageUrl
        ),
        name: name?.trim(),
        selectedPreset:selectedGDCustomPreset._id,
      };
      dispatch(updateStatus(UPLOAD_STATUS.PROJECT_CREATE_IN_PROGRESS));
      const response = await createProject(payload);
      if (get(response, "data.success", false)) {
        if(googleDriveInstruction?.instructionFile || googleDriveInstruction?.instructionText){
        const formData = new FormData();
        formData.append('dmsuploadBulk',googleDriveInstruction?.instructionFile)
        formData.append('message',googleDriveInstruction?.instructionText)
        formData.append('authorId',user?.user?.email || user?.user?.phone)
        formData.append('jobId',response.data?.data?.jobId)
        if(response.data?.data?.jobId)
        await sendGoogleDriveInstruction(formData);
        }
        setSuccessText(name);
        showFileUploadSuccess();
        dispatch(updateProjectCreate(true));
        dispatch(reset());
        dispatch(updateShowDialog(false));

        dispatch(removeUnReadNotification(fileUploadId));
        dispatch(updateStatus(UPLOAD_STATUS.PROJECT_CREATE));
      }
    } catch (error) {
      Toast.error(get(error, "response.data.message", ERROR_MESSAGES.SOME_THING_WENT_WRONG));
      dispatch(updateStatus(UPLOAD_STATUS.FILE_UPLOAD_DONE));
    }finally{
      setIsLoading(false);
      dispatch(updateStatus(UPLOAD_STATUS.FILE_UPLOAD_DONE));
    }
  };

  const createProjectProgressTracker = (progressEvent, id) => {
    const progress = getUploadProgress(progressEvent);
    dispatch(updateFolderProgress({ id: id, progress: progress }));
  };

  const folderUploadConfirmHandler = async() => {
    setIsLoading(true);

    const folderCount = values(folders).length;
    values(folders).forEach(async (folder, idx) => {
      try {
        const payload = {
          name: folder?.name,
          imageURLs: folder?.files,
          selectedpreset:selectedGDCustomPreset._id,
        };
        dispatch(startFolderProjectCreate({ id: folder?.id }));
        dispatch(updateStatus(UPLOAD_STATUS?.PROJECT_CREATE_IN_PROGRESS));
        const options = {
          onUploadProgress: (progressEvent) => {
            createProjectProgressTracker(progressEvent, folder?.id);
          },
        };
        const response = await createProject(payload, options);
        if (get(response, "data.success", false)) {
          if(googleDriveInstruction?.instructionFile || googleDriveInstruction?.instructionText){
          const formData = new FormData();
          formData.append('dmsuploadBulk',googleDriveInstruction?.instructionFile)
          formData.append('message',googleDriveInstruction?.instructionText)
          formData.append('authorId',user?.user?.email || user?.user?.phone)
          formData.append('jobId',response.data?.data?.jobId)
          if(response.data?.data?.jobId)
          await sendGoogleDriveInstruction(formData);
          }

          dispatch(endFolderProjectCreate({ id: folder?.id }));

          if (idx === Object.values(folders).length - 1) {
            dispatch(updateShowDialog(false));
            setSuccessText(`${folderCount} Projects`);
            showFileUploadSuccess();
            dispatch(reset());
            dispatch(updateStatus(UPLOAD_STATUS.PROJECT_CREATE_IN_DONE));
            dispatch(removeUnReadNotification(folder?.id));
          }
        } else {
          dispatch(updateStatus(UPLOAD_STATUS.PROJECT_CREATE_FAILED));
          dispatch(endFolderProjectCreate({ id: folder?.id }));
        }
      } catch (error) {
        const message = get(error, "response.data.message", ERROR_MESSAGES.SOME_THING_WENT_WRONG);
        Toast.error(message);
        dispatch(updateStatus(UPLOAD_STATUS.FOLDER_UPLOAD_DONE));
        dispatch(endFolderProjectCreate({ id: folder?.id }));
      }finally{
        setIsLoading(false);
        dispatch(updateStatus(UPLOAD_STATUS.FOLDER_UPLOAD_DONE));
      }
    });
  };

  const linkedAccountConfirmHandler = async() => {
    setIsLoading(true);
    dispatch(updateStatus(UPLOAD_STATUS.PROJECT_CREATE_IN_PROGRESS));
    try {
      const params = {
        marketplace: linkedAccountType?.toLowerCase(),
        productIds: selectedLinkedAccountProjectList.map((obj) => obj?.ID),
        marketplaceId: selectedMarketPlaceId,
        selectedPreset:selectedGDCustomPreset._id,
      };
      const response = await saveShopifyAccountBulkUpload(params);

      if (response.data?.success === true) {
        dispatch(setUploadedSuccesfully(response.data?.data?.success));
        dispatch(setLinkedAccountStep(STEPS.LINKED_ACCOUNT_STEP_4));
        dispatch(updateStatus(UPLOAD_STATUS.PROJECT_CREATE_IN_DONE));
      }
    } catch (err) {
      dispatch(updateStatus(UPLOAD_STATUS.PROJECT_CREATE_FAILED));
      console.error(err);
    }finally{
      setIsLoading(false);
      dispatch(updateStatus(UPLOAD_STATUS.PROJECT_CREATE_IN_DONE));
    }
  };

  const googleDriveConfirmHandler = async() => {
    try {
      setIsLoading(true);
      dispatch(updateStatus(UPLOAD_STATUS.PROJECT_CREATE_IN_PROGRESS));
      
      const response = await createGoogleDriveJob({
        marketplaceId: selectedGDCustomPreset._id,
        driveLink: googleDriveUserLink,
        jobName:userGoogleDriveFilesName
      });
      if (response.data.statusCode === 200) {
        if(googleDriveInstruction?.instructionFile || googleDriveInstruction?.instructionText){
        const formData = new FormData();
        formData.append('dmsuploadBulk',googleDriveInstruction?.instructionFile)
        formData.append('message',googleDriveInstruction?.instructionText)
        formData.append('authorId',user?.user?.email || user?.user?.phone)
        formData.append('jobId',response.data?.data?.jobId)
        await sendGoogleDriveInstruction(formData);
        }
        dispatch(setGoogleDriveStep(STEPS.GOOGLE_DRIVE_STEP_4));
        dispatch(updateStatus(UPLOAD_STATUS.PROJECT_CREATE_IN_DONE));
      }
    } catch (error) {
      if(error?.response?.status === 504){
        Toast.error(error?.response?.statusText);
      }else{
      Toast.error(error?.response?.data?.message || "Something went wrong");
      }
      dispatch(updateStatus(UPLOAD_STATUS.PROJECT_CREATE_FAILED));
    }finally{
      setIsLoading(false);
      dispatch(updateStatus(UPLOAD_STATUS.PROJECT_CREATE_IN_DONE));
    }
  }
  const confirmOrderHandler = async () => {
    if (!selectedGDCustomPreset?._id) {
      setErrorMessage(true);
      Toast.error("Please select a preset");
      return;
    }
    switch(step){
      case STEPS?.FILE_UPLOAD:
        fileUploadConfirmHandler();
        break;
      case STEPS?.FOLDER_UPLOAD:
        folderUploadConfirmHandler();
        break;
      case STEPS?.LINKED_ACCOUNT:
        linkedAccountConfirmHandler();
        break;
      case STEPS?.GOOGLE_DRIVE:
        googleDriveConfirmHandler();
        break;
      default:
        break;
    }
  };

  useEffect(()=>{
    creditCalculateHandler();
  },[selectedGDCustomPreset]);


  return (
    <div>
      <div
        style={{
          padding: "16px 24px 16px 24px",
          borderBottom: "1px solid #EEEEEE",
          position: "relative",
        }}
        ref={ref}
      >
        <Searchbar onChange={onSearchHandler} placeholderCTA='Search preset'/>
        {isComponentVisible && (
          <Box
            sx={{
              position: "absolute",
              top: "55px",
              maxHeight: "300px",
              minHeight: "50px",
              width: "calc(100% - 48px)",
              left: 24,
              background: "#fff",
              zIndex: 30,
              borderRadius: "0px 0px 8px 8px",
              border: "1px solid #EEEEEE",
              cursor: "pointer",
            }}
          >
            {searchResult?.map((item, index) => (
              <Box
                key={index}
                sx={{
                  width: "100%",
                  height: "60px",
                  background:
                    item?._id === selectedGDCustomPreset?._id
                      ? "#F9F9F9"
                      : "#fff",
                  borderBottom: "1px solid #EEEEEE",
                  pl: "16px",
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={() => onSelectHandler(item)}
              >
                <Box
                  sx={{ display: "flex", flexDirection: "column", gap: "8px" }}
                >
                  <span
                    style={{
                      fontSize: "14px",
                      color: "#262626",
                      fontWeight:
                        item?._id === selectedGDCustomPreset?._id && "bold",
                    }}
                  >
                    {item?.name}
                  </span>
                  <span
                    style={{
                      fontSize: "10px",
                      color: "rgba(38, 38, 38, 0.7)",
                      fontWeight:
                        item?._id === selectedGDCustomPreset?._id && "bold",
                    }}
                  >
                    {item?.width && item?.height
                      ? `Size: ${item?.width} * ${item?.height} ,`
                      : ""}{" "}
                    {item?.background
                      ? `Background: ${item?.background} ,`
                      : ""}{" "}
                    {item?.extension ? `Format: ${item?.extension}` : ""}
                  </span>
                </Box>
              </Box>
            ))}
          </Box>
        )}
      </div>
      <Box
        flex={1}
        position={"relative"}
        display={"flex"}
        flexDirection={"column"}
        height={"380px"}
        overflow={"auto"}
      >
        {searchResult?.map((item) => (
          <PresetFileCard
            key={item?.id}
            item={item}
            isSelected={selectedGDCustomPreset?._id === item?._id}
            onSelectHandler={onSelectHandler}
          />
        ))}
        {errorMessage && (
          <Box
            position={"absolute"}
            bottom={0}
            left={"50%"}
            sx={{ transform: "translate(-50%,-50%)" }}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            fontSize={"12px"}
            color={"red"}
            gap="10px"
            height="39px"
            backgroundColor="#fff"
            border='1px solid #EEEEEE'
            width="226px"
            borderRadius={"20px"}
          >
            <SvgIconStyle
              src="/images/errorIcon.svg"
              alt=""
              sx={{ width: "13px", height: "13px", background: "red" }}
            />
            Please choose the preset
          </Box>
        )}
      </Box>
      <Box
        sx={{
          position:'relative',
          width: "100%",
          minHeight:'99px',
          p: "10px 24px",
          "-webkit-box-shadow": "0px 0px 300px 200px rgba(0,0,0,0.03)",
          "-moz-box-shadow": "0px 0px 300px 200px rgba(0,0,0,0.03)",
          "box-shadow": "0px 0px 300px 200px rgba(0,0,0,0.03)",
        }}
      >
        {(showInstruction && step !== STEPS?.LINKED_ACCOUNT) ? 
        <AddInstruction setShowInstruction={setShowInstruction}/> :<><Box
          fontSize={"12px"}
          display={"flex"}
          gap="8px"
          pb="10px"
          justifyContent={"space-between"}
        >
          {(step !== STEPS?.LINKED_ACCOUNT) ? <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
              backgroundColor: "#F9F9F9",
              borderRadius: "15px",
              border: "1px solid #EEEEEE",
              p: "3px 10px",
              fontSize: "12px",
              cursor: "pointer",
            }}
            onClick={()=>setShowInstruction(true)}
          >
            <img src="/images/zoom-in.svg" alt="" width="16px" />
            {( googleDriveInstruction?.instructionFile || googleDriveInstruction?.instructionText )? 'Instructions added' : 'Add instructions'}
          </Box> : <Box></Box>}
          <Box
            display={"flex"}
            fontWeight={"bold"}
            fontSize="12px"
            gap="8px"
            alignItems={"center"}
          >
           {(selectedGDCustomPreset?.cost && 
             (step === STEPS?.FILE_UPLOAD ||
              step === STEPS?.FOLDER_UPLOAD ||
              step === STEPS?.GOOGLE_DRIVE)) && 
              <><span
              style={{
                display: "flex",
                minWidth: "60px",
                textDecoration: "underline",
              }}
            >
              {`Calculated Credit(s) : ${totalCredit}`}
            </span>
            <Box>
             <img src="/images/exclamation.svg" alt="" onClick={()=>setShowInfo(!showInfo)} style={{cursor:'pointer'}}/>
             {showInfo && 
             <Box sx={{position:'absolute',bottom:90,left:'3%',width:'95%',height:'212px',border:'1px solid #EEEEEE',borderRadius:'8px',background:'#fff'}}>
               <Box  sx={{...infoStyle,height:'56px'}}>
                 <Typography 
                    fontSize={'14px'} 
                    fontWeight={'bold'}>
                      Project Summary
                 </Typography>
                 <img 
                    src="/images/cancel.svg" 
                    alt="" 
                    width="18px" 
                    height="18px" 
                    style={{cursor:'pointer'}} 
                    onClick={()=>setShowInfo(false)} 
                 />
               </Box>
               <Box sx={infoStyle}>
                 <Typography 
                    fontSize={'12px'}>
                      Total Images:
                 </Typography>
                 <Typography 
                    fontSize={'12px'}>
                      { totalImages }
                 </Typography>
               </Box>
               <Box sx={infoStyle}>
                 <Typography 
                     fontSize={'12px'}>
                      Credits:
                 </Typography>
                 <Typography 
                     fontSize={'12px'}>
                      {
                       totalCredit
                      }
                 </Typography>
               </Box>
               <Box 
                 sx={{...infoStyle,gap:'11px',border:'none',justifyContent:'center'}}>
                 <img src="/images/exclamation.svg" alt="" />
                 <Typography 
                    fontSize={'12px'}>
                    Calculated credits might vary with the change in the total count of images.
                 </Typography>
               </Box>
             </Box>}
            </Box></>}
          </Box>
        </Box>
        <Button
          sx={{ ...MuiButtonStyle.loadingButton, width: "100%" }}
          onClick={confirmOrderHandler}
          disabled={isLoading}
        >
          {isLoading ? (
            <CircularProgress size={"18px"} color="inherit" thickness={5} />
          ) : (
            "Confirm Order"
          )}
        </Button></>}
      </Box>
    </div>
  );
};

export default SelectPresetAndConfirm;
